import moment from 'moment'
jQuery(document).ready(function ($) {
	// Tour
	$.ajax({
		url: 'https://rest.bandsintown.com/artists/Gavin%20Degraw/events?app_id=45PRESS_gavin-degraw',
		method: 'GET',
		dataType: 'json',
		xhrFields: {
			withCredentials: false
		},
		error: () => {},
		success: (data) => {
			const events = $('#events')
			let html = ''
			// console.log(data);
			if (data.length) {
				for (let event of data) {
					let region = event.venue.region
						? event.venue.region
						: event.venue.country
					const event_location = event.venue.city + ', ' + region
					html += '<div class="event" data-bit-id="' + event.id + '">'
					html +=
						'<div class="event-date">' +
						moment(event.datetime).format('MMM DD') +
						'</div>'
					html += '<div>'
					html += '<div class="event-location">' + event_location + '</div>'
					html += '<div class="event-venue">' + event.venue.name + '</div>'
					html += '</div>'
					if (event.offers[0]) {
						html +=
							'<a href="' +
							event.offers[0].url +
							'" target="_blank" class="btn btn-alt btn-small">Tickets</a>'
					} else {
						html +=
							'<a href="' +
							event.url +
							'" target="_blank" class="btn btn-alt btn-small">More Info</a>'
					}
					html += '</div>'
				}
				events.html(html)
			} else {
				events.html('No upcoming events.')
			}
		}
	})

	// More Events Button
	$('#more-events-button').click(function () {
		$('#events').toggleClass('view-all')
		const text = $(this).text()
		if (text === 'View all') {
			$(this).text('Less Events')
		} else {
			$(this).text('View all')
		}
	})

	// Newsletter Signup
	$('#gavin-degraw-smn-email-sign-up-website').on('submit', function (e) {
		// Prevent default browser actions on form submission.
		e.preventDefault()
		// Get all the form user submitted data and get it ready to be sent.
		var data = $(this).serialize()
		// POST all the data to the SMF submission endpoint URL.
		$.ajax({
			type: 'POST',
			url: 'https://subs.sonymusicfans.com/submit',
			dataType: 'json',
			data: data,
			xhrFields: {
				withCredentials: false
			},
			success: function (data) {
				// Do things on successful submission.
				$('#gavin-degraw-smn-email-sign-up-website').html(
					'<span class="thank-you">Thanks for signing up!</span>'
				)
			},
			error: function (err) {
				// Do things when submission has an error.
				alert('An error has occurred!')
			}
		})
	})
})
